import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Textarea,
} from "@windmill/react-ui";
import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
//internal import
import spinnerLoadingImage from "assets/img/spinner.gif";
import { SidebarContext } from "context/SidebarContext";
import AdminServices from "services/AdminServices";
import VendorServices from "services/VendorServices";
import VehicleServices from "services/VehicleServices";
import DriverServices from "services/DriverServices";
import { notifyError, notifySuccess } from "utils/toast";
import useToggleDrawer from "hooks/useToggleDrawer";
const RemarkModal = ({ id_data, block_data, title_data }) => {
  const { setServiceId } = useToggleDrawer();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [remarks, setRemarks] = useState("");
  const { blockIsModalOpen, closeModal, setIsUpdate } =
    useContext(SidebarContext);
  const location = useLocation();
  const handleBlocks = async () => {
    if (!remarks) {
      notifyError("Provide a Valid Remark");
    } else {
      setIsSubmitting(true);
    }

    try {
      let blockStatus;

      if (block_data === 0) {
        blockStatus = 1;
      } else if (block_data === 1) {
        blockStatus = 0;
      }

      if (location.pathname === "/vendor") {
        if (block_data !== undefined && block_data !== "") {
          if (remarks !== undefined && remarks !== "") {
            const res = await VendorServices.updateVendorBlockStatus(id_data, {
              status: blockStatus,
              remarks: remarks,
            });
            setIsUpdate(true);
            notifySuccess(res.message);
            setServiceId("");
            closeModal();
            setIsSubmitting(false);
          }
        }
      }

      if (location.pathname === "/vehicle") {
        if (block_data !== undefined && block_data !== "") {
          if (remarks !== undefined && remarks !== "") {
            const res = await VehicleServices.updateVehicleBlockStatus(
              id_data,
              {
                status: blockStatus,
                remarks: remarks,
              }
            );
            setIsUpdate(true);
            notifySuccess(res.message);
            setServiceId("");
            setRemarks("");
            closeModal();
            setIsSubmitting(false);
          }
        }
      }

      if (location.pathname === "/driver") {
        if (block_data !== undefined && block_data !== "") {
          if (remarks !== undefined && remarks !== "") {
            const res = await DriverServices.updateDriverBlockStatus(id_data, {
              status: blockStatus,
              remarks: remarks,
            });
            setIsUpdate(true);
            notifySuccess(res.message);
            setServiceId("");
            setRemarks("");
            closeModal();
            setIsSubmitting(false);
          }
        }
      }
      if (location.pathname === "/employee") {
        if (block_data !== undefined && block_data !== "") {
          if (remarks !== undefined && remarks !== "") {
            const res = await AdminServices.updateStaffStatus(id_data, {
              status: blockStatus,
              remarks: remarks,
            });
            setIsUpdate(true);
            notifySuccess(res.message);
            setServiceId("");
            closeModal();
            setIsSubmitting(false);
          }
        }
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  const handleRemarkChange = (e) => {
    setRemarks(e.target.value);
  };
  return (
    <>
      <Modal isOpen={blockIsModalOpen} onClose={closeModal}>
        <ModalBody className="custom-modal">
          <h2 className="text-lg font-medium mb-2">
            Enter remark to {block_data === 0 ? "Block" : "Unblock"}{" "}
            <span className="text-red-500">{title_data}</span>
          </h2>
          <Textarea
            name="block_remark"
            value={remarks}
            style={{
              minHeight: "100px",
              maxHeight: "300px",
              scrollbarWidth: "thin",
            }}
            onChange={handleRemarkChange}
          />
        </ModalBody>

        <ModalFooter className="justify-center">
          <Button
            className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
            layout="outline"
            onClick={closeModal}
          >
            Cancel
          </Button>
          <div className="flex justify-end">
            {isSubmitting ? (
              <Button
                disabled={true}
                type="button"
                className="w-full h-12 sm:w-auto"
              >
                <img
                  src={spinnerLoadingImage}
                  alt="Loading"
                  width={20}
                  height={10}
                />{" "}
                <span className="font-serif ml-2 font-light">Processing</span>
              </Button>
            ) : (
              <Button onClick={handleBlocks} className="w-full h-12 sm:w-auto">
                Submit
              </Button>
            )}
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default React.memo(RemarkModal);
